export const AppData = {
    AppName: "Beetrele",
    AppDomain: "beetrele.com",
} as const;
